import React from "react";
import PropTypes from "prop-types";
import "../styles/components/SeparatorText.css";
import { jarallaxElement } from "jarallax";
import { upperCase } from "lodash";

const SeparatorText = ({ text, paddingTop, paddingBottom, alignToRight }) => {
  jarallaxElement();
  const textUpperCase = upperCase(text);

  return (
    <div
      className="container container-small separator-text"
      style={{
        paddingTop: paddingTop,
        paddingBottom: paddingBottom,
        textAlign: alignToRight ? "right" : "left"
      }}
      id={textUpperCase}
    >
      <div className="row">
        <div
          data-jarallax
          data-speed="0.3"
          data-jarallax-element="0 500"
          className={`col-12 jarallax`}
        >
          <span>{textUpperCase}</span>
        </div>
      </div>
    </div>
  );
};

SeparatorText.propTypes = {
  text: PropTypes.string.isRequired,
  paddingTop: PropTypes.number.isRequired,
  paddingBottom: PropTypes.number.isRequired,
  alignToRight: PropTypes.bool
};

export default SeparatorText;
